<template>
  <el-container>
    <el-header>
      <el-menu
        :default-active="defaultActive"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu index="1">
          <template slot="title">Facebook</template>
          <el-menu-item index="1-1">用户</el-menu-item>
          <el-menu-item index="1-2">帖子</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">抖音</template>
          <el-menu-item index="2-1">用户</el-menu-item>
          <el-menu-item index="2-2">视频</el-menu-item>
          <el-menu-item index="2-3">用户橱窗</el-menu-item>
          <el-menu-item index="2-4">店铺商品</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">快手</template>
          <el-menu-item index="3-1">用户</el-menu-item>
          <el-menu-item index="3-2">视频</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">小红书</template>
          <el-menu-item index="4-1">用户</el-menu-item>
          <el-menu-item index="4-2">日记</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">YOUTUBE</template>
          <el-menu-item index="5-1">视频</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">INS</template>
          <el-menu-item index="6-1">帖子</el-menu-item>
          <el-menu-item index="6-2">用户</el-menu-item>
        </el-submenu>
        <el-submenu index="7">
          <template slot="title">Twitter</template>
          <el-menu-item index="7-1">用户</el-menu-item>
          <el-menu-item index="7-2">帖子</el-menu-item>
        </el-submenu>
        <el-submenu index="12">
          <template slot="title">Tiktok</template>
          <el-menu-item index="12-1">视频</el-menu-item>
          <el-menu-item index="12-2">用户</el-menu-item>
          <el-menu-item index="11-2">tiktok商品</el-menu-item>
        </el-submenu>
        <el-submenu index="8">
          <template slot="title">工具</template>
          <el-menu-item index="8-1">时间戳水印</el-menu-item>
          <el-menu-item index="8-2">抖音口令转换</el-menu-item>
          <el-menu-item index="8-3">荣耀截图列表</el-menu-item>
            <el-menu-item index="8-4">tiktok截图</el-menu-item>
          <el-menu-item index="generateJdShortLink">京东分享链接解析</el-menu-item>
          <el-menu-item index="generatetbShortLink">淘系[淘天、闲鱼]分享链接解析</el-menu-item>
          <el-menu-item index="generatedyShortLink">抖音分享链接解析</el-menu-item>

        </el-submenu>
        <el-submenu index="9">
          <template slot="title">Pinterest</template>
          <el-menu-item index="9-1">图片</el-menu-item>
        </el-submenu>
        <el-submenu index="10">
          <template slot="title">直播</template>
          <el-menu-item index="10-1">抖音直播</el-menu-item>
          <el-menu-item index="10-2">快手直播</el-menu-item>
          <el-menu-item index="diantaoLiveRooms">点淘直播</el-menu-item>
          <el-menu-item index="baiduLiveRooms">百度直播</el-menu-item>
          <el-menu-item index="pddLiveRooms">拼多多直播</el-menu-item>
          <el-menu-item index="diantaoLiveShevles">点淘直播货架</el-menu-item>
        </el-submenu>
        <el-submenu index="11">
          <template slot="title">其它</template>
<!--          <el-menu-item index="11-1">搜索引擎广告</el-menu-item>-->
          <el-menu-item index="wechatArtDetails">公众号文章[剪贴板]</el-menu-item>
          <el-menu-item index="wechatVideoInfoDetails">视频号视频信息解析</el-menu-item>
          <el-menu-item index="kuaishouPlaybackDetails">快手直播回放解析</el-menu-item>
          <el-menu-item index="douyinGroupMallDetails">抖音团购店铺[详情]</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      defaultActive: "1-1",
      value: "",
    };
  },
  mounted() {
    if (this.$route.name) {
      let obj = this.$route.name;
      this.defaultActive = this.reverseDisplay(obj);
      if (this.defaultActive) {
        this.handleSelect(this.defaultActive);
      }
    }
  },
  methods: {
    handleSelect(key) {
      if (key === "1-1") {
        this.$router.push({ path: "facebookPeople" });
      } else if (key === "1-2") {
        this.$router.push({ path: "facebookTopic" });
      } else if (key === "2-1") {
        this.$router.push({ path: "douyinPeople" });
      } else if (key === "2-2") {
        this.$router.push({ path: "douyinVideo" });
      } else if (key === "2-3") {
        this.$router.push({ path: "douyinBillboardGoodsItem" });
      } else if (key === "2-4") {
        this.$router.push({ path: "douyinShopGoodsItem" });
      } else if (key === "3-1") {
        this.$router.push({ path: "kuaishouPeople" });
      } else if (key === "3-2") {
        this.$router.push({ path: "kuaishouVideo" });
      } else if (key === "4-1") {
        this.$router.push({ path: "redbookPeople" });
      } else if (key === "4-2") {
        this.$router.push({ path: "redbookNote" });
      } else if (key === "5-1") {
        this.$router.push({ path: "youtubeVideo" });
      } else if (key === "6-1") {
        this.$router.push({ path: "insNote" });
      } else if (key === "6-2") {
        this.$router.push({ path: "insPeople" });
      } else if (key === "7-1") {
        this.$router.push({ path: "twitterPeople" });
      } else if (key === "7-2") {
        this.$router.push({ path: "twitterTopic" });
      } else if (key === "8-1") {
        this.$router.push({ path: "watermarkTools" });
      } else if (key === "8-2") {
        this.$router.push({ path: "generateDouCode" });
      } else if (key === "8-3") {
        this.$router.push({ path: "honorCaptureImages" });
      } else if (key === "8-4") {
        this.$router.push({ path: "tiktokScreenShot" });
      } else if (key === "9-1") {
        this.$router.push({ path: "pinterestImage" });
      } else if (key === "10-1") {
        this.$router.push({ path: "douyinLiveRooms" });
      } else if (key === "10-2") {
        this.$router.push({ path: "kuaishouLiveRooms" });
      } else if (key === "11-1") {
        this.$router.push({ path: "searchSiteAdvInfo" });
      } else if (key === "11-2") {
        this.$router.push({ path: "tiktokGoodsItem" });
      } else if (key === "12-1") {
        this.$router.push({ path: "tiktokVideoItem" });
      } else if (key === "12-2") {
        this.$router.push({ path: "tiktokUserItem" });
      } else if (key === "diantaoLiveRooms") {
        this.$router.push({ path: "diantaoLiveRooms" });
      } else if (key === "baiduLiveRooms") {
        this.$router.push({ path: "baiduLiveRooms" });
      } else if (key === "pddLiveRooms") {
        this.$router.push({ path: "pddLiveRooms" });
      } else if (key === "diantaoLiveShevles") {
        this.$router.push({ path: "diantaoLiveShevles" });
      } else if (key === "generateJdShortLink") {
        this.$router.push({ path: "generateJdShortLink" });
      } else if (key === "generatetbShortLink") {
        this.$router.push({ path: "generatetbShortLink" });
      } else if (key === "generatedyShortLink") {
        this.$router.push({ path: "generatedyShortLink" });
      } else if (key === "wechatArtDetails") {
        this.$router.push({ path: "wechatArtDetails" });
      } else if (key === "douyinGroupMallDetails") {
        this.$router.push({ path: "douyinGroupMallDetails" });
      } else if (key === "wechatVideoInfoDetails") {
        this.$router.push({ path: "wechatVideoInfoDetails" });
      } else if (key === "kuaishouPlaybackDetails") {
        this.$router.push({ path: "kuaishouPlaybackDetails" });

      }
    },
    reverseDisplay(val) {
      if (val === "facebookPeople") {
        return "1-1";
      } else if (val === "facebookTopic") {
        return "1-2";
      } else if (val === "douyinPeople") {
        return "2-1";
      } else if (val === "douyinVideo") {
        return "2-2";
      } else if (val === "douynBillboardGoodsItem") {
        return "2-3";
      } else if (val === "douyinShopGoodsItem") {
        return "2-4";
      } else if (val === "kuaishouPeople") {
        return "3-1";
      } else if (val === "kuaishouVideo") {
        return "3-2";
      } else if (val === "redbookPeople") {
        return "4-1";
      } else if (val === "redbookNote") {
        return "4-2";
      } else if (val === "youtubeVideo") {
        return "5-1";
      } else if (val === "insNote") {
        return "6-1";
      } else if (val === "insPeople") {
        return "6-2";
      } else if (val === "twitterPeople") {
        return "7-1";
      } else if (val === "twitterTopic") {
        return "7-2";
      } else if (val === "generateDouCode") {
        return "8-2";
      } else if (val === "pinterestImage") {
        return "9-1";
      } else if (val === "douyinLiveRooms") {
        return "10-1";
      } else if (val === "searchSiteAdvInfo") {
        return "11-1";
      } else if (val === "tiktokGoodsItem") {
        return "11-2";
      } else if (val === "tiktokVideoItem") {
        return "12-1";
      } else if (val === "tiktokUserItem") {
        return "12-2";
      } else if (val === "watermarkTools") {
        return "8-1"
      } else if (val === "diantaoLiveRooms") {
        return "diantaoLiveRooms"
      } else if (val === "baiduLiveRooms") {
        return "baiduLiveRooms"
      } else if (val === "pddLiveRooms") {
        return "pddLiveRooms"
      } else if (val === "diantaoLiveShevles") {
        return "diantaoLiveShevles"
      } else if (val === "generateJdShortLink") {
        return "generateJdShortLink"
      } else if (val === "generatetbShortLink") {
        return "generatetbShortLink"
      } else if (val === "generatedyShortLink") {
        return "generatedyShortLink"



      } else if (val === "wechatArtDetails") {
        return "wechatArtDetails"
      } else if (val === "douyinGroupMallDetails") {
        return "douyinGroupMallDetails"
      } else if (val === "wechatVideoInfoDetails") {
        return "wechatVideoInfoDetails"
      } else if (val === "kuaishouPlaybackDetails") {
        return "kuaishouPlaybackDetails"


      } else {
        return "1-1";
      }
    },
  },
};
</script>
